import * as React from 'react';
import { IconImage16 } from '@cian/ui-kit/icons';
import { InlineText1 } from '@cian/ui-kit/typography';
import * as styles from './NoImage.css';

export const NoImage = (props: { text?: string }) => {
  const { text = 'Нет фото' } = props;

  return (
    <div className={styles['image']}>
      <div className={styles['image-icon']}>
        <IconImage16 display="block" color="white_60" />
      </div>
      <InlineText1 fontWeight={'bold'} color={'gray60_100'}>
        {text}
      </InlineText1>
    </div>
  );
};
